import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { ButtonThemeService, THEME_CONSTANTS } from 'ui-components/services/button-theme-service';
import { DropdownMenuPositionPropType } from 'ui-components/prop-types/dropdown-menu-position';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';

import { AddToBatchDropdownItems } from './add-to-batch-dropdown-items';

import style from './add-to-batch-dropdown.module.less';

const AddToBatchDropdown = ({
  disabled = false,
  addIdsToBatch,
  createBatchWithIds,
  children = <FormattedMessage defaultMessage='Add to Batch' description='addToBatchDropdown.addToBatch' id='eYXccR' />,
  tabIndex = 0,
  togglerClassName = '',
  togglerTheme = THEME_CONSTANTS.white,
  togglerOpenClassname = '',
  hide = false,
  hideChevron = false,
  menuPosition,
  shouldShowLoadMoreButton = false,
  loadMore,
}) => {
  if (hide) {
    return null;
  }

  return (
    <div className={style['add-to-batch-wrapper']}>
      <DropdownMenu disabled={disabled} menuPosition={menuPosition}>
        <DropdownMenuToggler
          className={togglerClassName}
          hideChevron={hideChevron}
          openClassName={togglerOpenClassname}
          tabIndex={tabIndex}
          theme={togglerTheme}
        >
          {children}
        </DropdownMenuToggler>
        <AddToBatchDropdownItems
          addIdsToBatch={addIdsToBatch}
          createBatchWithIds={createBatchWithIds}
          loadMore={loadMore}
          shouldShowLoadMoreButton={shouldShowLoadMoreButton}
        />
      </DropdownMenu>
    </div>
  );
};

AddToBatchDropdown.propTypes = {
  disabled: PropTypes.bool,
  addIdsToBatch: PropTypes.func.isRequired,
  createBatchWithIds: PropTypes.func.isRequired,
  children: PropTypes.node,
  tabIndex: PropTypes.number,
  togglerClassName: PropTypes.string,
  togglerTheme: PropTypes.oneOf(ButtonThemeService.getButtonThemes()),
  togglerOpenClassname: PropTypes.string,
  hide: PropTypes.bool,
  hideChevron: PropTypes.bool,
  menuPosition: DropdownMenuPositionPropType,
  shouldShowLoadMoreButton: PropTypes.bool,
  loadMore: PropTypes.func.isRequired,
};

export default AddToBatchDropdown;
